export default __webpack_public_path__ + "static/media/downloadCloudGold.92bd0efa.svg";